import HomeCleaningIcon from "@/assets/images/3d-icons/home-cleaning.png";
import type { TodoCardProps } from "../TodoCard";
import { useGetVisitsQuery } from "@/gqlhooks/visit/useGetVisitsQuery";
import { useRoute } from "@/components/shared/router";
import { useAuthState } from "@/store/auth";
import { otherServiceItems, popularServiceItems } from "../../lib";
import { formatDate } from "@/lib/helpers/date";
import { addMonths } from "date-fns";
import {
  VisitStatusEnum,
  SortEnum,
  VisitSortByEnum,
} from "@/__generated__/graphql";
import { getServiceNameFromDepartment } from "@/lib/booking-lib";
const services = [...popularServiceItems(), ...otherServiceItems()];
export const useServiceScheduleCard = (): TodoCardProps | null => {
  const { push } = useRoute();
  const clientId = useAuthState((state) => state.data.userInfo.id);
  const unscheduledQuery = useGetVisitsQuery({
    skip: !clientId,
    fetchPolicy: "cache-and-network",
    variables: {
      filters: {
        clientId: [clientId],
        from: formatDate(new Date()),
        to: formatDate(addMonths(new Date(), 1)),
        status: [
          VisitStatusEnum.PendingClientSchedule,
          VisitStatusEnum.UnableToSchedule,
        ],
        sortBy: [VisitSortByEnum.ServiceDate],
        sort: [SortEnum.Asc],
      },
    },
  });
  const firstUnscheduledVisit = unscheduledQuery.list[0];

  if (!firstUnscheduledVisit) return null;

  const serviceName = getServiceNameFromDepartment(
    firstUnscheduledVisit.department,
  );
  const service = services.find((service) => service.name === serviceName);
  const description = "Set your schedule";

  const handleSetSchedule = () => {
    push({ pageKey: "visits" });
  };

  return {
    onClick: handleSetSchedule,
    image: service?.icon || HomeCleaningIcon,
    title: service?.title || "Service",
    desc: description,
  };
};
